export default "__VITE_ASSET__CthxkM8c__"